/** Bookings tab — the /bookings grid, pinned to this user.
 *
 * Reuses the whole page rather than a bespoke grid, so the tab keeps the query
 * language, batch actions, the column set and export. `fixedUserId` composes a
 * match-by-PK condition into every request (list, count and batch) and locks
 * the `user` namespace out of the query widget. See BookingsPage's embedded
 * mode, and the tour-operator Staff tab for the same pattern over UsersListPage.
 */
import { Box } from '@mui/material';

import { BookingsPage } from '@/features/bookings/BookingsPage';

interface Props {
  userId: number;
}

export function BookingsTab({ userId }: Props) {
  return (
    <Box>
      <BookingsPage fixedUserId={userId} />
    </Box>
  );
}
